// extracted by mini-css-extract-plugin
module.exports = {"item":"DropdownFilter_item__5i08z","active":"DropdownFilter_active__8kICq"};